// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  login: {
    welcome: 'Welcome',
    title: 'Login to Timi',
    subtitle: 'Enter your credentias.',
    dontHaveAnAccount: 'Don’t have an account?',
    email: 'Email',
    password: 'Password',
    emailPlaceholder: 'Email address',
    remember: 'Remember me',
    forgot: 'Forgot your password?',
    login: 'Sing in',
    or: 'O',
    register: 'Get started',
    success: '¡Bienvenido/a! Estamos felices de tenerte de vuelta.',
    error: '¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.',
    error_email: 'Email no válido',
    MEMBER_NOT_FOUND: 'Email not valid',
    error_password: 'XXXXXXXXña no válida',
    error_remember: 'Recuérdame no válido',
    error_login: 'Error al iniciar sesión',
    error_register: 'Error al registrar',
    error_forgot: 'Error al enviar correo de recuperación',
    error_forgot_email: 'Email no válido',
    error_forgot_password: 'XXXXXXXXña no válida',
    error_forgot_remember: 'Recuérdame no válido',
    error_forgot_success: '¡Correo de recuperación enviado! Por favor, revisa tu bandeja de entrada.',
    error_forgot_error: '¡Ups! Algo salió mal. Por favor, inténtalo de nuevo.',
  },
  menu: {
    checker: 'Checker',
    members: 'Members',
    attendance: 'Attendance',
  },
  checker: {
    placeholderCheckerInput: 'Type your email@vinnere.com.mx',
    erroValidationEmail: 'Invalid email format!',
    successCheckin: 'Success Register!',
    qrWelcome: 'Welcome',
    qrDescriptor: 'Scan the following code to check in',
    employerListTitle: 'Today in office',
    colaborator: 'Collaborator',
    hour: 'Time',
    checkerSubmitButton: 'Submit',
  },
  attendance: {
    titlePage: 'Checador: Attendance',
    title: 'Attendance List',
    tableHeadersColaborator: 'Colaborator',
    tableHeadersOwner: 'Owner',
    tableHeadersPosition: 'Position',
    tableHeadersCheckin: 'Checkin',
    tableHeadersCheckout: 'Checkout',
    tableHeadersEstatus: 'Status',
    tableHeadersMedio: 'Medio',
    downloadExcel: 'Download Excel',
    startDate: 'Start Date',
    endDate: 'End Date',
    placeholderSerach: 'Filter by Name or E-mail...',
  },
  members: {
    pageTitle: 'Members',
    tableHeadersFullName: 'Colaborator',
    tableHeadersEmail: 'Email',
    tableHeadersPosition: 'Position',
    tableHeadersOwner: 'Owner',
    tableHeadersStatus: 'Status',
    alertTitle: 'Are you sure to exec this command?',
    alertConfirmation: 'Please confirm.',
    alertCancel: 'Cancel',
    alertConfirm: 'Ok',
  },
  member: {
    pageTitle: 'Detail',
    attendanceHistory: 'Attendance History',
    position: 'Position',
    owner: 'Owner',
    status: 'Status',
    previousWeek: 'Previous Week',
    nextWeek: 'Next Week',
    tableHeadersDate: 'Date',
    tableHeadersCheckin: 'Checkin',
    tableHeadersCheckout: 'Checkout',
    tableHeadersMedio: 'Medio',
    tableHeadersEstatus: 'Status',
    tableHeadersAcciones: 'Actions',
    homeAddress: 'Home Address',
    officeAddress: 'Office Address',
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
};

export default en;
